import React from "react";

const ExternalLinkIcon = ({
  className = "w-5 h-5",
  viewBox = "0 0 20 20",
  fill = "none",
  stroke = "currentColor",
  strokeWidth = "1.5",
  ...props
}) => (
  <svg
    className={className}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 7.5L12.5 2.5M17.5 7.5V2.5M17.5 7.5H12.5M7.5 2.5H6.5C5.39543 2.5 4.5 3.39543 4.5 4.5V5.5M7.5 17.5H6.5C5.39543 17.5 4.5 16.6046 4.5 15.5V14.5M17.5 12.5V13.5C17.5 14.6046 16.6046 15.5 15.5 15.5H14.5"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExternalLinkIcon;
